import { createFileRoute } from '@tanstack/react-router';
import { EntityStyleOrderDocumentsTable } from '@/app/(client)/my-styles/-components/EntityStyleOrderDocumentsTable';
import { styleOrderDocumentsQueryOptions } from '@/app/(client)/my-styles/-hooks/useStyleOrderDocumentsQuery';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/linked/',
)({
  loader: ({ params }) =>
    queryClient.ensureQueryData(
      styleOrderDocumentsQueryOptions(params.id, { page: 1, count: 20 }),
    ),
  component: LinkedDocumentsRoute,
});

function LinkedDocumentsRoute() {
  const { id } = Route.useParams();
  return <EntityStyleOrderDocumentsTable entityId={id} />;
}
